import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { MFRepositories } from '@sennder/microfrontend-registry'
import { MicroFrontend } from '@sennder/microfrontend-registry/vue'
import { SharedDataType } from '@sennder/senn-node-microfrontend-interfaces'

export default /*#__PURE__*/_defineComponent({
  __name: 'AcceleratedPaymentMF',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(MicroFrontend), {
    repository: _unref(MFRepositories).AcceleratedPayment,
    app: "acceleratedPayment",
    integrator: _unref(SharedDataType).ORCAS,
    props: undefined
  }, null, 8 /* PROPS */, ["repository", "integrator"]))
}
}

})